import './index.scss';

const PageTitle = ({ label, tag = 'h1', className = '', children, ...rest }) => {
    const Tag = tag;

    return (children || label) && (
        <Tag className={`page-title ${className}`} {...rest}>
            {children || label}
        </Tag>
    );
};

export default PageTitle;
